import { hasCapability, type User } from "../base";

export const bidTable = {
  read: (user: User) => hasCapability(user, "bidTable.read"),
  update: (user: User) => hasCapability(user, "bidTable.update"),
};
